module.exports = __webpack_public_path__ + "media/styles/images/png/logo-gray-17703d2d9b3801153f93fd53dddf60dd.png";